var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import * as ReactDOM from "react-dom";
export { useState, useId, useReducer, useEffect, useLayoutEffect, useInsertionEffect, useTransition, useDeferredValue, useSyncExternalStore, startTransition, useRef, useImperativeHandle, useMemo, useCallback, useContext, useDebugValue, version, Children, render, hydrate, unmountComponentAtNode, createPortal, createElement, createContext, createFactory, cloneElement, createRef, Fragment, isValidElement, isFragment, isMemo, findDOMNode, Component, PureComponent, memo, forwardRef, flushSync, unstable_batchedUpdates, StrictMode, Suspense, SuspenseList, lazy, } from "preact/compat";
// eslint-disable-next-line surveyjs/no-imports-from-entries
import { Survey, PopupSurvey } from "../../survey-react-ui/entries/react-ui-model";
import { SurveyModel } from "survey-core";
export function renderSurvey(model, element, props) {
    if (props === void 0) { props = {}; }
    var survey = React.createElement(Survey, __assign({ model: model }, props));
    ReactDOM.render(survey, element);
}
export function renderPopupSurvey(model, element, props) {
    if (props === void 0) { props = {}; }
    var survey = React.createElement(PopupSurvey, __assign({ model: model }, props));
    ReactDOM.render(survey, element);
}
function doPopupSurvey(props) {
    return this.each(function () {
        renderPopupSurvey(props.model, this, props);
    });
}
var gcontext = globalThis;
if (typeof globalThis === "undefined")
    gcontext = window;
var jQueryInst = gcontext["jQuery"] || gcontext["$"];
if (typeof jQueryInst !== "undefined") {
    initJquery(jQueryInst);
}
else {
    try {
        jQueryInst = require("jquery");
        initJquery(jQueryInst);
    }
    catch (ex) {
    }
}
function initJquery(instance) {
    instance["fn"].extend({
        Survey: function (props) {
            return this.each(function () {
                renderSurvey(props.model, this, props);
            });
        },
        PopupSurvey: doPopupSurvey,
        SurveyWindow: doPopupSurvey
    });
}
SurveyModel.platform = "js-ui";
SurveyModel.prototype["render"] = function (element) {
    if (element === void 0) { element = null; }
    if (this.renderCallback) {
        this.renderCallback();
    }
    else {
        renderSurvey(this, element);
    }
};
export var preact = React;
export * from "../../survey-react-ui/entries/react-ui-model";
export { SurveyModel, SurveyWindowModel, SurveyModel as Model, settings, surveyLocalization, surveyStrings } from "survey-core";
import { checkLibraryVersion } from "survey-core";
checkLibraryVersion("".concat(process.env.VERSION), "survey-js-ui");
